import {useQuery} from "@tanstack/react-query";
import {Token, UsersApi} from "@devour/client";
import getConfig from "@/utils/getConfig";

interface UseGetUserLeaderboardRankOptions {
    enabled?: boolean;
}

async function fetchUserLeaderboardRank(fullToken: Token): Promise<{ rank: number }> {
    return await new UsersApi(getConfig(fullToken)).getUsersLeaderboardRank();
}

function useUserLeaderboardRank(fullToken: Token, options: UseGetUserLeaderboardRankOptions = {}) {
    return {
        queryKey: [
            "user-leaderboard-rank",
            fullToken?.id ?? "unauthorized",
        ],
        queryFn: () => fetchUserLeaderboardRank(fullToken),
        staleTime: 30 * 1000,
        enabled: !!fullToken && (options.enabled ?? true),
    } as const;
}

export function useGetUserLeaderboardRank(fullToken: Token, options: UseGetUserLeaderboardRankOptions = {}) {
    return useQuery(useUserLeaderboardRank(fullToken, options));
}